<!--配置 数据库表的字段和 instance tag关系-->

<template>
  <div v-cloak v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ path:'/home' }"><i class="fa fa-home"></i> Home</router-link>
        </li>
        <li class="active">
          <small>Config Table Field& Abstract Tag</small>
        </li>
      </ol>
    </div>

    <confirmation-box ref="deleteFieldTagBox" @handleConfirm ="handleDeleteConfig"></confirmation-box>

    <div class="tab">
      <el-tabs class="el-tabs" type="border-card">
        <el-tab-pane label="Detail">

          <add-table-tag ref="addTableTag" @saveSuccess = "handleQuery"></add-table-tag>
          <edit-table-tag ref="editTableTag" @saveSuccess = "handleQuery"></edit-table-tag>
          <edit-field-tag ref="editFieldTag" @saveSuccess = "handleQuery"></edit-field-tag>
          <add-field-tag ref="addFieldTag" @saveSuccess = "handleQuery"></add-field-tag>

          <el-collapse v-model="activeNames"><!--form表单折叠板-->
            <el-collapse-item name="1">
              <template slot="title">
          <span style="text-align: right;width: 100%"> <template v-if="activeNames.includes('1')"> Collapse Filter </template>
             <template v-else> Expand Filter </template>
            &nbsp; </span>
              </template>
              <div class="query-form">
                <el-form ref="queryForm" label-width="100px" label-position="top">
                  <el-row  :gutter="20">
                  <el-col :xs="12" :sm="8" :md="6" :lg="4">
                    <el-form-item label="DB Url">
                      <el-input v-model ="queryDTO.dbUrl" size="mini">

                      </el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="12" :sm="8" :md="6" :lg="4">
                    <el-form-item label="Schema Name">
                      <el-input v-model ="queryDTO.schemaName" size="mini" >

                      </el-input>
                    </el-form-item>
                  </el-col>

                    <el-col :xs="12" :sm="8" :md="6" :lg="4">
                      <el-form-item label="Table Name">
                        <el-input v-model ="queryDTO.tableName" size="mini">

                        </el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :xs="12" :sm="8" :md="6" :lg="4">
                      <el-form-item label="Field Name">
                        <el-input v-model ="queryDTO.fieldName" size="mini">

                        </el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :xs="12" :sm="8" :md="6" :lg="4">
                      <el-form-item label="Abstract Tag">
                        <el-input v-model ="queryDTO.tagName" size="mini">

                        </el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :xs="12" :sm="8" :md="18" :lg="24">
                      <el-form-item>
                        <div class="search-reset">
                          <el-button type="primary" size="mini" @click="handleQuery"><i class="fa fa-search"
                                                                                        aria-hidden="true"></i>Search
                          </el-button>
                          <el-button type="warning" size="mini" @click="handleResetForm()"><i class="fa fa-eraser"
                                                                                              aria-hidden="true"></i>Reset
                          </el-button>
                        </div>
                      </el-form-item>
                    </el-col>


                  </el-row>




                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="tool-bar">
            <el-row :gutter="10">
              <el-col :span="24">
                <div class="adapt-top adapt-bottom" style="text-align: right">

                  <el-button type="primary" size="mini" @click="handleAddTable">
                    Add
                  </el-button>
                  <el-button  type="danger" size="mini" @click="openConfirmBox">
                    Delete
                  </el-button>
                </div>
              </el-col>

            </el-row>
          </div>


          <div class="table" v-loading="tableDataLoading"
               :element-loading-text="loadingPrompt"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)">
      <!-- Notice: table,field的id都用uuid，避免发生重复 -->
                  <el-table
            :data="tableData"
            style="width: 100%;margin-bottom: 20px;"
            row-key="id"
            border
            default-expand-all
            :tree-props="{children: 'children'}"
            @select="handleSelect"
            @select-all="handleSelectAll"
            :row-class-name = "tableRowClassName"
                  >


                    <el-table-column type="selection" width="46"></el-table-column>
            <el-table-column
              prop="dbUrl"
              label="DB Url"
              min-width="150">
            </el-table-column>
            <el-table-column
              prop="schemaName"
              label="Scheme Name"

              min-width="150">
            </el-table-column>
            <el-table-column
              prop="tableName"
              min-width="150"
              label="Table Name">
            </el-table-column>

            <el-table-column
              prop="fieldName"
              label="Field Name"

              min-width="180">
            </el-table-column>

            <el-table-column
              prop="tagName"
              label="Abstract Tag"
              min-width="180">
            </el-table-column>


            <el-table-column
              label="Operation" min-width="200px">

              <template slot-scope="scope">
                <div  v-if="scope.row.type =='table'" style="color: red;text-align: center">
                  <el-button  @click="handleAddField(scope)" size="mini" >add field tag</el-button>
                  <el-button  @click="handleEditTable(scope)" size="mini" >edit</el-button>

                </div>

                <div  v-if="scope.row.type =='field'" style="color: red;text-align: center">
                  <el-button  @click="handleEditField(scope)" size="mini" >edit</el-button>
                </div>



              </template>

            </el-table-column>
          </el-table>
          </div>

          <div class="tool-bar" style="width: 100%;text-align: right" v-if="showPagination">

            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total=totalRecord>
              </el-pagination>
            </div>


          </div>



        </el-tab-pane>
      </el-tabs>
    </div>

  </div>

</template>

<script>


  import confirmationBox from '@/components/dialog/confirmation_box.vue'
  import addTableTag from '@/view/acs/table/dialog/add_table_tag.vue'
  import editFieldTag from '@/view/acs/table/dialog/edit_field_tag.vue'
  import addFieldTag from '@/view/acs/table/dialog/add_field_tag.vue'
  import editTableTag from '@/view/acs/table/dialog/edit_table_tag.vue'

  export default {
    props: {

    },
    components: {
      confirmationBox,
      addTableTag,
      editFieldTag,
      addFieldTag,
      editTableTag
    },
    data(){
      return{
        loadTreeFirstTime:true,
        abstractTreeData:[],
        dataLoading: false,
        activeNames:['1'],
        tableDataLoading:false,
        loadingPrompt:'Loading ',
        showPagination: true,
        queryDTO:{
          dbUrl:'',
          schemaName:'',
          tableName:'',
          fieldName:'',
          tagName:''
        },
        queryUrl: '/acs/table-field-tag-config/list',
        pageSize:20,
        currentPage: 0,
        totalRecord: 0,
        tableData:[],
        selection:[],
        scope:{}
      }
    },
    computed: {
      fullQueryUrl(){
        let url = this.baseAcsUrl + this.queryUrl;
        url += (url.indexOf("?") !== -1) ? "&" : "?";
        url += this.pageParam;
        return url;
      },
      pageParam() {
        if(this.showPagination){
          let realQueryPage = this.currentPage - 1;
          let param = 'page=' + realQueryPage + '&size=' + this.pageSize;
          return param;
        }
        return "";
      },
      detailParam(){
        let params = {};
        if(this.queryDTO){
          if(this.queryDTO.dbUrl){
            params.dbUrl = this.queryDTO.dbUrl;
          }
          if(this.queryDTO.schemaName){
            params.schemaName = this.queryDTO.schemaName;
          }
          if(this.queryDTO.tableName){
            params.tableName = this.queryDTO.tableName;
          }
          if(this.queryDTO.fieldName){
            params.fieldName = this.queryDTO.fieldName;
          }
          if(this.queryDTO.tagName){
            params.tagName = this.queryDTO.tagName;
          }
        }
        return params;
      },

    },
    created(){
      this.runQuery();
    },



    methods: {
      runQuery(){
        this.http.post(this.fullQueryUrl,this.detailParam).then(resp =>{
          let data = resp.data;
          this.totalRecord = data.totalElements;
          this.tableData = data.content;
        }).catch(error =>{

        })
      },

      handleQuery() {
        this.currentPage = 1;
        this.runQuery();
      },
      handleResetForm() {
        this.queryDTO ={
          dbUrl:'',
          schemaName:'',
          tableName:'',
          fieldName:'',
          tagName:''
        };
        this.currentPage = 1;
        this.runQuery();
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.runQuery();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.runQuery();
      },
      refresh() {
        this.runQuery();
      },
      handleAddTable(){
        this.getAbstractTree('add');

      },
      handleDeleteConfig(){
          let selection = this.selection;
          let deleteList = [];

          for(var i in selection){
            let deleteItem = {};
            deleteItem.id = selection[i].id;
            deleteItem.type = selection[i].type;
            deleteItem.tableId = selection[i].tagTableId;
            deleteList.push(deleteItem);
          }

          let url = this.baseAcsUrl +"/acs/table-field-tag-config/delete";
        this.dataLoading = true;
          this.http.delete(url,deleteList).then(resp =>{
            this.$message.success("Operation Success");

            this.dataLoading = false;
            this.$refs.deleteFieldTagBox.hideDialog();
            this.runQuery();
          }).catch(error => {
            this.dataLoading = false;
            console.info(error);
          })


      },
      getAbstractTree(type){
        if(this.loadTreeFirstTime){
          let url = this.baseAcsUrl +"/acs/data-abstract-tag/get-tree";
          this.dataLoading = true;
          this.http.get(url).then(resp =>{
            //this.structure = resp.data;
            this.abstractTreeData =resp.data;
            this.dataLoading = false;
            // load一次以后就直接传值啦
            this.loadTreeFirstTime =false;

            this.openDialog(type);
          }).catch(error => {
            this.dataLoading = false;
            console.info(error);
          });
        }else{
          this.openDialog(type);
        }
      },
      openDialog(type){
        if(type == 'add'){
          this.$refs.addTableTag.showDialog();
          this.$refs.addTableTag.initAbstractTreeData(this.abstractTreeData);
        }else if(type == 'edit field'){
          let row = this.scope.row;
          this.$refs.editFieldTag.showDialog(row);
          this.$refs.editFieldTag.initAbstractTreeData(this.abstractTreeData);
        }else if(type == 'add field'){
          let row = this.scope.row;
          this.$refs.addFieldTag.showDialog(row);
          this.$refs.addFieldTag.initAbstractTreeData(this.abstractTreeData);
        }else if(type == 'edit'){
          let row = this.scope.row;
          this.$refs.editTableTag.showDialog(row);
          this.$refs.editTableTag.initAbstractTreeData(this.abstractTreeData);
        }
      },
      openConfirmBox(){
        let selection = this.selection;
        if( selection.length == 0){
          this.$message.warning("Please choose at least one record");
          return;
        }
        console.log(this.selection);
        this.$refs.deleteFieldTagBox.showDialog();
      },
      handleAddField(scope){

        this.scope = scope;
        this.getAbstractTree("add field");
      },
      handleEditTable(scope){
        console.log(scope);
        this.scope = scope;
        this.getAbstractTree("edit");
      },
      handleEditField(scope){
        console.log("edit field");
        console.log(scope);
        this.scope = scope;
        this.getAbstractTree("edit field");
      },
      handleSelect(selection, row) {
        this.selection = selection;
      },
      handleSelectAll(selection) {
        this.selection = selection;
      },
      tableRowClassName({row,rowIndes}){
        if(row && row.type == 'table'){
          return 'warning-row';
        }
      },
      // 提供给abstract使用，如果更改了。这里需要重新load值
      changeAbstractTree(){
        this.loadTreeFirstTime = true;
        this.$refs.addTableTag.setFirstTime();
        this.$refs.editTableTag.setFirstTime();
        this.$refs.editFieldTag.setFirstTime();
        this.$refs.addFieldTag.setFirstTime();
      }


    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .text-right {
    text-align: right;
    margin-right: 100px;
  }

  .adapt-top {
    margin-top: 10px;

  }

  .adapt-bottom {
    margin-bottom: 10px;
  }

  .pagination {
    display: inline-block;
    padding-left: 0;
    margin: 12px 0;
    border-radius: 4px;
  }


  .adapt-bottom {
    margin-bottom: 20px;
  }

  .templet {
    color: #FFFFFF
  }

  .e-label {
    font-weight: bold;
  }

  .name {
    font-size: 16px;
    padding: 5px 0;
    float: left;
  }

  .product-name {
    margin-bottom: 20px;
  }

  .width-adapt {
    width: 500px;
  }

  /deep/ tr.warning-row {
    background: oldlace;
  }

  .table /deep/ .current-row > td {
    /*background: rgba(0, 158, 250, 0.219) !important;*/
    background: deepskyblue;
  }

  /*.table .success-row {*/
  /*!*background: #f0f9eb;*!*/
  /*background: red;*/

  /*}*/

  .success-row {
    background: #f0f9eb;
  }

  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange
  .el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 100%;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
    /*height: 26px;*/
    /*margin-top: 8px;*/
  }
  .el-form--label-top /deep/ .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 10px;
    line-height: 10px;
    font-size: 12px;
    margin-bottom: -16px;

  }

  /deep/ .el-input--small  .el-input__inner {
    height: 32px ! important ;
    line-height: 32px;
  }
  .el-select-small /deep/ .el-input--small /deep/ .el-input__inner {
    height: 32px ;
    line-height: 32px;
  }

  .el-range-editor--small .el-range__close-icon, /deep/ .el-range-editor--small .el-range__icon {
    line-height: 20px;
  }

  /*.el-date-editor /deep/ .el-range-separator {*/
  /*  line-height: 20px;*/
  /*  width: 5%;*/
  /*  color: #303133;*/
  /*  font-size: 12px;*/
  /*}*/

  .cell-value{
    cursor: pointer;
    color: #1c15ff;
    text-decoration:underline;
  }


  /deep/ .el-table td, /deep/ .el-table th{
    padding: 0px 0;
  }

  /deep/ .el-table{
    font-size: 12px;
  }

  /deep/ .el-table thead{
    color:black;
  }



  /*/deep/ .el-input__prefix .el-input__icon{*/
  /*  width:10px;*/
  /*  line-height: 40px;*/
  /*}*/

  /*/deep/ .el-input--prefix .el-input__inner{*/
  /*  padding-left: 18px;*/
  /*}*/


  /*/deep/ .el-input--suffix .el-input__inner{*/
  /*  padding-right: 5px;*/
  /*}*/


  /deep/ .el-collapse-item__content{
    padding-bottom: 10px;
  }


  /deep/ .el-form-item {
    margin-bottom: 0px;
  }

  /deep/ .el-collapse-item__header{
    height: 35px;
    line-height: 35px;
  }




  .data-region{
    /*box-shadow:2px 2px  5px 3px lightgray;*/
    margin-top: 10px;
  }

  .tool-bar , /deep/ .el-table {
    padding-left: 5px;
    padding-right: 5px;

  }

  /deep/ .el-table {
    width: auto;
  }

  .el-select{
    width: 100%;
  }

  /deep/ .el-table th {
    background-color: #e5e9ec94;
  }


  /deep/ .el-table__empty-text{
    font-size: 15px;
  }
  .search-reset{
    text-align: right;
    margin-top: 22px;

  }
  .data-region /deep/ .el-button--mini{
    min-width: 70px;
  }
  .dialog-footer /deep/ .el-button{
    padding: 7px 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/acs/table/config_field_tag.vue